module.exports = __webpack_public_path__ + "icon-trash.png?d086c10a2ffa96558d4d27dc279288a1";